import {gql} from "@apollo/client";

export const GET_TODAY_RESERVATION_OCCUPATION = gql`
    query reservationOccupations {
        reservationOccupations
    }
`;

export const GET_TODAY_APPOINTMENT_OCCUPATION = gql`
    query appointmentOccupations {
        appointmentOccupations
    }
`;

export const GET_UPCOMING_RESERVATIONS = gql`
    query upcomingReservations($days: Int!) {
        upcomingReservations(days: $days) {
            fromDate
            toDate
            animals {
                name
                sex
                uuid
            }
        }
    }
`

export const GET_CURRENT_RESERVATIONS = gql`
    query currentReservations {
        currentReservations {
            fromDate
            toDate
            animals {
                name
                sex
                uuid
                attentions {
                    subject
                }
            }
        }
    }
`

export const SUBMIT_ATTENTION = gql`
    mutation submitAttention($animalUuid: String!, $subject: String!) {
        submitAttention(animalUuid: $animalUuid, subject: $subject)
    }
`

// Upcoming appointments for dashboard (GraphQL)
export const GET_UPCOMING_APPOINTMENTS = gql`
    query upcomingAppointments($limit: Int) {
        upcomingAppointments(limit: $limit) {
            id
            startAt
            endAt
            service { name bufferBeforeMinutes bufferAfterMinutes  }
            status
            staff { id  person { name forename }}
            animal { uuid name attentions { id subject } }
            customer { name forename  }
        }
    }
`;
